import { Injectable } from '@angular/core'
import {
  HttpClient,
  HttpContext,
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { GLOBAL_LOADING_SPINNER_ENABLED } from 'src/app/shared/interceptors/loading-spinner-interceptor'

// subset of the fields returned by the user endpoint
export type User = Readonly<{
  name: string
  given_name: string
  family_name: string
  email: string
  preferred_username: string
  roles: readonly string[]
  groups: readonly string[]
  exp: number
}>

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private readonly http: HttpClient) {}

  getUser(): Observable<User> {
    return this.http.get<User>(
      'user',
      { context: new HttpContext().set(GLOBAL_LOADING_SPINNER_ENABLED, false) },
    )
  }
}
